import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private httpService: HttpService) { }
  dashboardData(payload: any) {
    return this.httpService.post(`api/Dashboard/StatisticsReport`, payload);
  }
  dashboardGetYearlyExpenseReportData(payload: any) {
    return this.httpService.get(
      `api/Dashboard/GetYearlyExpenseReport/${payload?.year}/${payload?.companyAccountId}`
    );
  }
  GetAllDashboardData(payload: any) {
    return this.httpService.post(
      'api/Dashboard/GetAllDashboardData',
      payload
    );
  }
  GetOverallExpensesReportData(payload: any) {
    return this.httpService.post(
      'api/Dashboard/GetOverallExpensesReportData',
      payload
    );
  }
  GetFinancialYearData(params: URLSearchParams) {
    return this.httpService.get(
      'api/Dashboard/GetFinancialYearData/?' + params.toString()
    );
  }
  GetDeviceSessions(userId: string) {
    return this.httpService.post(
      'api/Dashboard/GetAndUpdateDeviceTokenKeyDetails',
      { userId }
    );
  }
  RemoveDeviceSession(id: string, cleanToken: string) {
    const params = new URLSearchParams({ id, cleanToken: cleanToken ?? '' });
    return this.httpService.post(
      'api/Dashboard/RemoveDeviceTokenKeyDetails?' + params.toString(),
      {}
    );
  }
  GetTeamListData(id: string) {
    return this.httpService.get(
      `api/Dashboard/GetTeamListData?Id=${encodeURIComponent(id ?? '')}`
    );
  }
}
